import { Box, Stack, StackProps } from '@mui/material';
import { ReactElement } from 'react';
import { useIsMobile } from '@synergy/components-next';

export interface EmptyStateProps extends StackProps {
    icon?: ReactElement;
}

export const EmptyState = (props: EmptyStateProps): ReactElement => {
    const isMobile = useIsMobile();
    const { children, icon, ...stackProps } = props;

    return (
        <Stack
            textAlign="center"
            alignItems="center"
            gap={3}
            sx={{ maxWidth: isMobile ? '440px' : '600px', margin: 'auto' }}
            {...stackProps}
        >
            {icon && <Box sx={{ fontSize: isMobile ? '48px' : '56px' }}>{icon}</Box>}
            <Stack gap={1.5} alignItems="center">
                {children}
            </Stack>
        </Stack>
    );
};
